



















































































import { defineComponent } from '@vue/composition-api';
import { ProductCategoryOption } from '@/models/entities/ProductCategoryOption';

interface Props {
  entityOptions: ProductCategoryOption[];
}

const Component = defineComponent({
  name: 'ProductCategoryOptionsSimpleTable',

  props: {
    entityOptions: Array,
  },

  setup() {
    function changeOption(option: ProductCategoryOption) {
      option.hasOverriddenValue = true;
    }
    return { changeOption };
  },
});
export default Component;
